/* eslint-disable */
import React from 'react';

// David's 16-unit, 1.5-stroke icon grammar for the v6 bar (prototype `I` map). cls = the size class from the caller.
const P = (d, extra = {}) => <path d={d} {...extra} />;
const ICONS = {
  srch: { v: 16, s: 1.6, el: <><circle cx="7" cy="7" r="4.6" /><path d="M10.5 10.5L14 14" /></> },
  chev: { v: 10, s: 1.5, el: P('M2 3.8l3 3 3-3') },
  cvr: { v: 10, s: 1.6, el: P('M3.6 2l3.2 3-3.2 3') },
  x: { v: 10, s: 1.8, el: P('M2 2l6 6M8 2L2 8') },
  chk: { v: 10, s: 2, el: P('M1.8 5.2l2.2 2.2 4.2-4.6') },
  fun: { v: 16, s: 1.5, el: P('M2 3h12l-4.6 5.4V13l-2.8-1.4V8.4z', { strokeLinejoin: 'round' }) },
  sort: { v: 16, s: 1.5, el: P('M3 4h10M4.5 8h7M6.5 12h3') },
  grid: { v: 16, s: 1.5, el: <><rect x="2" y="2" width="5" height="5" rx="1.2" /><rect x="9" y="2" width="5" height="5" rx="1.2" /><rect x="2" y="9" width="5" height="5" rx="1.2" /><rect x="9" y="9" width="5" height="5" rx="1.2" /></> },
  list: { v: 16, s: 1.5, el: P('M2.5 4h11M2.5 8h11M2.5 12h11') },
  up: { v: 16, s: 1.5, el: P('M8 11V2.5M4.5 6L8 2.5 11.5 6M2.5 13.5h11') },
  down: { v: 16, s: 1.5, el: P('M8 2.5V11M4.5 7.5L8 11l3.5-3.5M2.5 13.5h11') },
  plus: { v: 16, s: 1.8, el: P('M8 3v10M3 8h10') },
  pen: { v: 16, s: 1.5, el: P('M10.8 2.6l2.6 2.6L6 12.6l-3.3.7.7-3.3z', { strokeLinejoin: 'round' }) },
  bm: { v: 16, s: 1.5, el: P('M4 2.5h8v11l-4-2.6-4 2.6z', { strokeLinejoin: 'round' }) },
  trash: { v: 16, s: 1.5, el: P('M2.5 4.5h11M6.5 4.5V2.8h3v1.7M4 4.5l.7 9h6.6l.7-9') },
  wifi: { v: 16, s: 1.5, el: P('M1.5 5.5a10 10 0 0 1 13 0M3.8 8.3a6.5 6.5 0 0 1 8.4 0M6.2 11a3 3 0 0 1 3.6 0M2 2l12 12') },
  undo: { v: 16, s: 1.5, el: <><path d="M6 9.5L2.5 6 6 2.5" /><path d="M2.5 6H10a3.8 3.8 0 0 1 0 7.5H8" /></> },
  bell: { v: 16, s: 1.5, el: P('M8 2.2a3.8 3.8 0 0 0-3.8 3.8c0 3.2-1.3 4.2-1.3 4.2h10.2S11.8 9.2 11.8 6A3.8 3.8 0 0 0 8 2.2zM6.6 12.6a1.5 1.5 0 0 0 2.8 0') },
  clock: { v: 16, s: 1.5, el: <><circle cx="8" cy="8" r="5.6" /><path d="M8 4.8V8l2.2 1.4" /></> },
  menu: { v: 16, s: 1.5, el: P('M2.5 4h11M2.5 8h11M2.5 12h11') },
};
export function Ic({ n, cls }) {
  const i = ICONS[n];
  return <svg className={cls} viewBox={`0 0 ${i.v} ${i.v}`} fill="none" stroke="currentColor" strokeWidth={i.s} strokeLinecap="round" aria-hidden="true">{i.el}</svg>;
}
export const Dots = ({ cls }) => <svg className={cls} viewBox="0 0 16 16" fill="currentColor" aria-hidden="true"><circle cx="3.5" cy="8" r="1.4" /><circle cx="8" cy="8" r="1.4" /><circle cx="12.5" cy="8" r="1.4" /></svg>;
export const Star = ({ cls, on }) => <svg className={cls} viewBox="0 0 16 16" fill={on ? 'currentColor' : 'none'} stroke="currentColor" strokeWidth="1.3" strokeLinejoin="round" aria-hidden="true"><path d="M8 1.8l1.9 3.9 4.3.6-3.1 3 .7 4.3L8 11.6l-3.8 2 .7-4.3-3.1-3 4.3-.6z" /></svg>;

// The stage trigger's ring (look C): six arcs in the stage colours, thicker when chosen, the others dimmed.
export function Donut({ stages, sel }) {
  const R = 7, cx = 10, cy = 10, g = 5, any = sel.size > 0;
  const pt = (a) => { const r = (a * Math.PI) / 180; return `${(cx + R * Math.cos(r)).toFixed(2)} ${(cy + R * Math.sin(r)).toFixed(2)}`; };
  return (
    <svg viewBox="0 0 20 20" fill="none" aria-hidden="true">
      {stages.map((s, i) => { const on = sel.has(s.key); return <path key={s.key} d={`M${pt(-90 + i * 60 + g)}A${R} ${R} 0 0 1 ${pt(-90 + (i + 1) * 60 - g)}`} stroke={s.c} strokeWidth={on ? 3.4 : 2.3} opacity={any && !on ? 0.28 : 1} />; })}
      {any && <circle cx="10" cy="10" r="1.7" fill="#f5a523" />}
    </svg>
  );
}
